import { StaticInformation } from "models/StaticInformation";

export const staticInformation: StaticInformation = {
  headOfficeAddressInformation: {
    title: "Ludvig & Co AB",
    streetAddress: "Franzéngatan 6",
    zipcode: "112 51",
    city: "Stockholm",
    email: "info@ludvig.se",
    phone: "0771-27 27 27"
  },
  informationArea: { title: "", textBlock: ["", "", ""] },
  supportContactInformation: {
    email: "mittkontor@ludvig.se",
    phone: "0770-77 97 00",
    externalSupportSite: "https://kundsupport.ludvig.se",
    internalSupportSite: "https://konsultsupport.ludvig.se"
  },
  globalSettings: { showDigitalServices: true, showFortnoxLink: true }
};
